import type { Group, GroupMembership } from 'src/models/group/_types';
import type { User } from 'src/models/user/_types';

interface IsGroupAdminArgs {
  user: User | null | undefined;
  group: Group | null | undefined;
}

export function isGroupAdmin({ user, group }: IsGroupAdminArgs): boolean {
  if (!user || !group) return false;
  const adminIds = Array.isArray(group.adminIds) ? group.adminIds : [];
  // user.id may be string/number; normalize to string for comparison
  const userId = String(user.id);
  return adminIds.map((id) => String(id)).includes(userId);
}

export function isGroupMember({
  group,
  memberships,
}: {
  group: Group;
  memberships: GroupMembership[] | null | undefined;
}): boolean {
  if (!group || !memberships || memberships.length === 0) return false;
  const gid = String(group.id);
  return memberships.some((m) => String(m.groupId) === gid);
}
